var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('img', {
    staticClass: "inline-image",
    attrs: {
      "src": _vm.urlFor(_vm.asset._ref).url()
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };